import { api } from '../index';

const prefix = '/api/sample/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectSampleList(param) {
	return api.post(prefix + 'selectSampleList', param);
}

export function apiSelectSample(param) {
	return api.post(prefix + 'selectSample', param);
}

// export function apiSelectInvoiceItemList(param) {
// 	return api.post(prefix + 'selectInvoiceItemList', param);
// }

// export function apiSelectInvoiceHistoryItemList(param) {
// 	return api.post(prefix + 'selectInvoiceHistoryItemList', param);
// }

export function apiInsertSample(param) {
	param.mode = 'insert';
	return apiSubmitSample(param);
	//return api.post(prefix + 'submitInvoice', param);
}

export function apiUpdateSample(param) {
	param.mode = 'update';
	//console.log(param);
	return apiSubmitSample(param);
	//return api.post(prefix + 'submitUser', param);
}

export function apiDeleteSample(param) {
	param.mode = 'delete';
	return apiSubmitSample(param);
}

function apiSubmitSample(param) {
	return api.post(prefix + 'submitSample', param);
}

export function apiSelectSampleInoutList(param) {
	return api.post(prefix + 'selectSampleInoutList', param);
}

export function apiSelectSampleInout(param) {
	return api.post(prefix + 'selectSampleInout', param);
}

// export function apiSelectSampleInoutItemList(param) {
// 	return api.post(prefix + 'selectSampleInoutList', param);
// }

export function apiInsertSampleInout(param) {
	return api.post(prefix + 'insertSampleInout', param);
}

export function apiSamplePickupStartBatch(param) {
	return api.post(prefix + 'pickupStartBatch', param);
}

export function apiSamplePickupCompleteBatch(param) {
	return api.post(prefix + 'pickupCompleteBatch', param);
}

export function apiUpdateSalesmanPickup(param) {
	return api.post(prefix + 'updateSalesmanPickup', param);
}

export function apiSampleDeletePickupInfo(param) {
	return api.post(prefix + 'deletePickupInfo', param);
}
